import React from 'react';

import cs from 'classnames';
import moment from 'moment-tz';

import {CountdownTime} from 'app/components/general/CountdownTime';
import updateIntervalEnhancer, {
  type UpdateIntervalEnhancerProps,
} from 'app/general/updateIntervalEnhancer';
import {gt} from 'app/utils/i18n';

import type {AttemptSerializedType} from 'sweet-types';

type Props = {
  attempt: AttemptSerializedType;
  duration?: number;
};

export const Countdown = updateIntervalEnhancer<Props>(
  ({attempt, duration}: Props & UpdateIntervalEnhancerProps) => {
    const due = moment(attempt.created_at).add(duration, 's');
    const isFinished = due.isSameOrBefore(moment());
    const isSoon = due.isBefore(moment().add(60 * 5, 's'));

    return (
      <div className="d-flex mb-2 align-items-center justify-content-between">
        <span className="text-muted font-italic mr-2 d-none d-sm-inline">
          {attempt.user.name}
        </span>
        {duration ? (
          <div
            className={cs('timer d-inline border rounded p-1 p-md-2', {
              'border-danger text-danger': isFinished,
              'border-warning text-warning': isSoon && !isFinished,
              'border-white text-muted': !isSoon,
            })}
          >
            {!isFinished ? (
              <>
                <CountdownTime
                  timestamp={moment(attempt.created_at).add(duration, 's')}
                />{' '}
                {gt('remaining')}
              </>
            ) : (
              <span>{gt("Time's up")}</span>
            )}
          </div>
        ) : null}
      </div>
    );
  },
  10 * 1000
);
